<script lang="ts">
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';

	export let name: string;
	export let options: Tab[];
	export let activeTab: Tab;
	export let underline = false;
	export let showArrow = false;
	export let syncHash = false;

	$: if (syncHash && browser) {
		history.replaceState(
			{},
			'',
			window.location.hash
				? window.location.href.replace(/#.*$/, `#${activeTab.id}`)
				: `#${activeTab.id}`
		);
		window.dispatchEvent(new HashChangeEvent('hashchange'));
	}

	const syncTab = (e: HashChangeEvent) => {
		const newTab = options.find((o) => o.id === window.location.hash.substring(1));
		if (newTab) {
			activeTab = newTab;
		}
	};
	onMount(() => {
		if (syncHash) {
			window.addEventListener('hashchange', syncTab);
		}

		return syncHash ? () => window.removeEventListener('hashchange', syncTab) : null;
	});
</script>

<div class="tabs flex space-x-1 shrink-0" class:arrow={showArrow} class:divider={underline}>
	{#each options as option}
		<input
			class="sr-only"
			type="radio"
			name="tab-{name}"
			value={option.id}
			bind:group={activeTab.id}
			id="tab-{name}-{option.id}"
		/>
		<label
			for="tab-{name}-{option.id}"
			class="whitespace-nowrap capitalize border-white mb-4 inline-flex items-center gap-2"
		>
			{#if option.showIndicator}
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 10 10"
					width="10"
					height="10"
					aria-hidden="true"
					focusable="false"
					class="text-blue"
				>
					<circle cx="5" cy="5" r="5" stroke="none" fill="currentColor" />
				</svg>
			{/if}
			<span>
				{option.title}
				{option.suffix || ''}
			</span></label
		>
	{/each}
</div>

<style lang="postcss">
	.tabs {
		overflow: auto;
		scrollbar-width: 0;
		margin-inline-start: -0.5rem;
		margin-block-end: 2rem;

		& label {
			padding: 0.5rem 0.5rem;
			margin: 0;
			color: theme('colors.gray.45');
			cursor: pointer;
			transition: color 150ms ease-in-out;
			position: relative;
		}

		& label:hover {
			color: theme('colors.black');
		}

		& input:checked + label {
			color: theme('colors.black');
		}

		& input:focus-visible + label {
			@apply focused;

			outline-offset: -2px;
		}
	}
	.arrow {
		& input:checked + label {
			&::before {
				content: '↓ ';
			}
		}
	}

	.divider {
		position: relative;

		&::after {
			position: absolute;
			content: '';
			left: 0.5rem;
			right: 0.5rem;
			bottom: 0;
			height: 1px;
			background-color: theme('borderColor.DEFAULT');
		}

		& input + label {
			padding-right: 3.75rem;
		}
		& input:checked + label {
			&::after {
				position: absolute;
				content: '';
				left: 0;
				right: 0;
				bottom: 0px;
				height: 1px;
				z-index: 1;
				background-color: theme('borderColor.white');
			}
		}
	}
</style>
